import Head from 'next/head'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import { getSeoDetails } from '@/store/slices/headSlice'

const Header = () => {
  const router = useRouter()
  const data = useSelector(getSeoDetails)
  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL.replace(/\/$/, '')
  const canonicalUrl = (baseUrl + (router.asPath === '/' ? '' : router.asPath)).split('?')[0]

  const headTag = document.getElementsByTagName('HEAD')[0]
  const desctiptionTag = document.createElement('META')
  const authorTag = document.createElement('META')
  const ogTitleTag = document.createElement('META')
  const ogDescriptionTag = document.createElement('META')
  const ogImageTag = document.createElement('META')

  useEffect(() => {
    document.title = `${data?.pageTitle}`

    authorTag.setAttribute('author', 'Speakers | United Talent Agency')

    desctiptionTag.setAttribute('description', `${data?.pageDescription}`)

    ogTitleTag.setAttribute('og:title', `${data?.pageTitle}`)
    ogDescriptionTag.setAttribute('og:description', `${data?.pageDescription}`)
    {
      data?.ogImage && ogImageTag.setAttribute('og:image', `${data?.ogImage}`)
    }
  })

  return (
    <>
      <Head>
        <link rel="canonical" href={canonicalUrl} />
        <link rel="icon" href="https://www.unitedtalent.com/favicon.ico" />
        {process.env.NEXT_PUBLIC_NODE_ENV === 'development' ||
        process.env.NEXT_PUBLIC_NODE_ENV === 'staging' ? (
          <meta name="robots" content="noindex" />
        ) : (
          ''
        )}
      </Head>
      <Head>
        <title>{data?.pageTitle}</title>
        <meta property="author" content="Speakers | United Talent Agency" key="author" />
        <meta property="description" content={data?.pageDescription} key="description" />
        <meta name="description" content={data?.pageDescription} key="name-description" />
        <meta property="og:title" content={data?.pageTitle} key="og-title" />
        <meta property="og:description" content={data?.pageDescription} key="og-description" />
        <meta property="og:image" content={data?.ogImage} key="og-image" />
        <meta property="og:url" content={canonicalUrl} key="og-url" />
        <meta property="og:type" content="website" key="og-type" />
      </Head>
    </>
  )
}

export default Header
